import { render } from "./ManufacturerSelect.vue?vue&type=template&id=ff33ca6a"
import script from "./ManufacturerSelect.vue?vue&type=script&lang=js"
export * from "./ManufacturerSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__